<div class="tooltip">

    i
    <span class="tooltiptext {{direction}} {{textAling}}">
        <p>{{text}}</p>
    </span>
</div>